/*
 * @Author: mzw
 * @Date: 2025-05-06 15:32:17
 * @LastEditTime: 2025-05-06 15:32:17
 * @LastEditors: mzw
 * @Description: 编辑框（未发出）数据存储
 * @FilePath: 
 */
import * as Storage from '@/utils/storage'
export default {
  state: {
    chatHomeData: Storage.getLocalStorage("chatHomeData") || {}, // AI工具
    // chatIntellectData: Storage.getLocalStorage("chatIntellectData") || {}, // AI智能体
  },
  getters: {
    getChatHomeData: (state) => (id) => {
      return state.chatHomeData[Number(id)];
    },
    // getChatIntellectData: (state) => (id) => {
    //   return state.chatIntellectData[Number(id)];
    // }
  },
  // mutations: {
  // },
  actions: {
    // 更新数据
    changeChatHomeData({ state, commit, dispatch }, {id, val}) {
      state.chatHomeData[Number(id)] = {
        ...val
      }
      Storage.setLocalStorage("chatHomeData", state.chatHomeData)
    },
    removeChatHomeData({ state, commit, dispatch }, id) {
      delete state.chatHomeData[Number(id)]
      Storage.setLocalStorage("chatHomeData", state.chatHomeData)
    },
    // changeChatIntellectData({ state, commit, dispatch },id, val) {
    //   state.chatIntellectData[Number(id)] = {
    //     ...val
    //   }
    //   // 问题：localStorge无法存储本地读取的文件及图片（文件信息是临时的）, 排除↓↓↓
    //   if(val.imageList.length<=0 && val.fileList.length<=0) {
    //     Storage.setLocalStorage("chatIntellectData", {...state.chatIntellectData})
    //   }
    // },
    // removeChatIntellectData({ state, commit, dispatch }, id) {
    //   delete state.chatIntellectData[Number(id)]
    //   Storage.setLocalStorage("chatIntellectData", state.chatIntellectData)
    // }
  }
}
